import { buildEvaluationRecord } from '@/utils/studentEvaluation'

// SDK-writeable data only. Derived staffAccess/referralOwnerIds are deliberately
// absent so a hosted smoke must exercise the trusted reconciliation worker.
export function buildReferralFixture({ key, uid, otherCm, schoolId, runId, studentId }) {
  const tag = { __smokeTest: true, __smokeRunId: runId, schoolId }
  return {
    student: {
      ...tag,
      app: {
        studentData: {
          firstName: 'SMOKE',
          lastName: `Referral ${key}`,
          plan: key === 'live504' ? '504' : 'IEP',
          planStatus: key === 'live504' ? '' : 'initial',
          caseManagerId: key === 'owned' ? '' : otherCm
        },
        schedule: { periods: { 1: { teacherId: uid, coTeaching: { caseManagerId: uid } } } },
        providers: { speechId: uid },
        flags: { separateSetting: true }
      }
    },
    evaluation: {
      ...buildEvaluationRecord({
        studentId,
        schoolId,
        evalType: 'IEP',
        caseManagerId: key === 'owned' ? uid : otherCm,
        createdBy: uid,
        dates: { referral: '2026-10-28' }
      }),
      ...tag
    },
    share: {
      ...tag,
      enabled: true,
      teachers: [uid],
      aides: [uid],
      caseManagers: [uid],
      serviceProviders: [uid],
      allowedData: { documents: true }
    }
  }
}
